import React, { useState } from 'react';
import { Card, Row, Col, Typography, Divider } from 'antd';
import { CloudOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const MOCK_WEATHER = {
  location: 'Ahmedabad, Gujarat',
  temp: 28,
  condition: 'Partly Cloudy',
  humidity: 65,
  wind: 12,
  icon: '⛅',
  forecast: [
    { day: 'Mon', icon: '☀️', high: 32, low: 22 },
    { day: 'Tue', icon: '🌤️', high: 30, low: 21 },
    { day: 'Wed', icon: '🌧️', high: 26, low: 19 },
    { day: 'Thu', icon: '⛈️', high: 24, low: 18 },
    { day: 'Fri', icon: '🌦️', high: 27, low: 20 },
    { day: 'Sat', icon: '☀️', high: 31, low: 22 },
    { day: 'Sun', icon: '☀️', high: 33, low: 23 },
  ],
};

export default function Weather() {
  const { t } = useTranslation();
  const [weather] = useState(MOCK_WEATHER);

  return (
    <div>
      <Title level={4} style={{ color: '#1a6b2a', marginBottom: 20 }}><CloudOutlined /> {t('weather')}</Title>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card style={{ borderRadius: 12, background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)', border: 'none', color: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14 }}>📍 {weather.location}</Text>
                <div style={{ fontSize: 64 }}>{weather.icon}</div>
                <div style={{ fontSize: 48, fontWeight: 700, color: '#fff' }}>{weather.temp}°C</div>
                <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 18 }}>{weather.condition}</Text>
              </div>
            </div>
            <Divider style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
            <Row>
              <Col span={12}>
                <Text style={{ color: 'rgba(255,255,255,0.8)' }}>💧 Humidity</Text>
                <div style={{ color: '#fff', fontWeight: 600, fontSize: 18 }}>{weather.humidity}%</div>
              </Col>
              <Col span={12}>
                <Text style={{ color: 'rgba(255,255,255,0.8)' }}>🌬️ Wind</Text>
                <div style={{ color: '#fff', fontWeight: 600, fontSize: 18 }}>{weather.wind} km/h</div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card title="7-Day Forecast" style={{ borderRadius: 12 }}>
            {weather.forecast.map((day) => (
              <div key={day.day} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                <Text strong style={{ width: 40 }}>{day.day}</Text>
                <span style={{ fontSize: 20 }}>{day.icon}</span>
                <Text style={{ color: '#ff4d4f' }}>{day.high}°</Text>
                <Text type="secondary">{day.low}°</Text>
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      <Card style={{ borderRadius: 10, marginTop: 16 }}>
        <Text type="secondary">
          ⚠️ Weather data shown is sample data. Connect to a weather API (e.g., OpenWeatherMap) using the farm location to get live data.
          Add <Text code>REACT_APP_OPENWEATHER_KEY</Text> to your .env file.
        </Text>
      </Card>
    </div>
  );
}
